<div mat-dialog-content cdkFocusInitial>
  <mat-card>
    <mat-card-header>
      <mat-card-title>DATOS DEL BENEFICIARIO</mat-card-title>
    </mat-card-header>
    <mat-card-content style="padding: 1.25rem 0">
      <mat-grid-list cols="3" rowHeight="2.813rem" gutterSize="0px">
        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Nombre</span>
            <span
              >{{ data.Nombre }} {{ data.ApellidoPaterno }}
              {{ data.ApellidoMaterno }}</span
            >
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Estado</span>
            <span>{{ data.Situacion || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-none">
          <div class="row">
            <span>Correo electronico</span>
            <span>{{ data.Correo || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Rut</span>
            <span>{{ data.Rut || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Recibe pago</span>
            <span>{{ data.Situacion || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-none">
          <div class="row">
            <span>Direccion particular</span>
            <span>{{ data.direccion || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Fecha de Nacimiento</span>
            <span>{{ formatDate(data.FechaNacimiento) || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Teléfono Particular</span>
            <span>{{ data.Telefono || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-none">
          <div class="row">
            <span>Ciudad</span>
            <span>{{ data.ciudad || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Parentesco</span>
            <span>{{ data.Parentesco || '-' }}</span>
          </div>
        </mat-grid-tile>

        <mat-grid-tile class="border-right">
          <div class="row">
            <span>Teléfono móvil</span>
            <span>{{ data.TelefonoMovil || '-' }}</span>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>

  <mat-grid-list cols="1" rowHeight="3rem" gutterSize="0px">
    <mat-grid-tile>
      <div class="modal-button">
        <button [mat-dialog-close]="" mat-stroked-button class="button-cerrar">
          Cerrar
        </button>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
